<template>
    <div class="w-100">
      <div class="container-box mx-auto">
        <div>
          <b-img class="w-100" src="/imgs/contactUs/banner.png"></b-img>
        </div>

        <div class="contact-whatwedo-box w-100 d-flex justify-content-around">
          <div class="contact-icon-box" v-for="(item,index) in items" :key="index">
            <div class="icon-items d-flex justify-content-center mx-auto">
              <b-img width="40" :src="'/imgs/contactUs/'+item.icon"></b-img>
            </div>
            <div class="text-center pt-3">
              <span class="d-block font-weight-bold">{{item.title}}</span>
              <div style="font-size: 13px">{{item.oneLine}}</div>
              <div style="font-size: 13px">{{item.twoLine}}</div>
            </div>
          </div>
        </div>

        <!-- Company Philosophy  -->
        <div class="w-100 d-flex justify-content-center align-items-center pt-5">
          <div>
            <b-img width="40" height="40" class="ml-4" src="/imgs/contactUs/iconfacebook.png"></b-img>
            <b-img width="40" height="40" class="ml-4" src="/imgs/contactUs/icontuite.png"></b-img>
            <b-img width="40" height="40" class="ml-4" src="/imgs/contactUs/icon_ins.png"></b-img>
            <b-img width="40" height="40" class="ml-4" src="/imgs/contactUs/iconinstagram.png"></b-img>
          </div>

        </div>

        <!-- Quality Assurance  -->
        <div class="w-100 d-flex justify-content-between pt-5 pb-5">
          <div class="border region-card" style='background-image: url("/imgs/contactUs/bg.png");'>
            <h2>{{getConfig.provName}}</h2>
            <ul class="list-unstyled">
              <li class="d-flex align-items-center">
              <span>
                <b-img src="/imgs/contactUs/icon_company.svg"></b-img>
              </span>
              <span>
                {{getConfig.corpName}}
              </span>
              </li>
              <li class="d-flex align-items-center">
              <span>
                <b-img src="/imgs/contactUs/icon_email.svg"></b-img>
              </span>
                <span>{{getConfig.mail}}</span>
              </li>
              <li class="d-flex align-items-center">
              <span>
                <b-img src="/imgs/contactUs/icon_phone.svg"></b-img>
              </span>
                <span>{{getConfig.phone}}</span>
              </li>
              <li class="d-flex align-items-center">
              <span>
                <b-img src="/imgs/contactUs/icon_address.svg"></b-img>
              </span>
                <span>{{getConfig.address}}</span>
              </li>
            </ul>
          </div>


          <div class="border region-card" style='background-image: url("/imgs/contactUs/bg.png");'>
            <h2>{{getConfig.provName1}}</h2>
            <ul class="list-unstyled">
              <li class="d-flex align-items-center">
              <span>
                <b-img src="/imgs/contactUs/icon_company.svg"></b-img>
              </span>
                <span>
                  {{getConfig.corpName1}}
                </span>
              </li>
              <li class="d-flex align-items-center">
              <span>
                <b-img src="/imgs/contactUs/icon_email.svg"></b-img>
              </span>
                <span>{{getConfig.mail1}}</span>
              </li>
              <li class="d-flex align-items-center">
              <span>
                <b-img src="/imgs/contactUs/icon_phone.svg"></b-img>
              </span>
                <span>{{getConfig.phone1}}</span>
              </li>
              <li class="d-flex align-items-center">
              <span>
                <b-img src="/imgs/contactUs/icon_address.svg"></b-img>
              </span>
                <span>{{getConfig.address1}}</span>
              </li>
            </ul>
          </div>
        </div>


      </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name:"contactUs",
  computed:{
    ...mapGetters(['getConfig'])
  },
  data(){
    return {
      config:{},
      items:[
        {
          title:'Address',
          oneLine:'Frederick Ave, Vancouver,',
          twoLine:'',
          content:'Frederick Ave, Vancouver, British Columbia, Canada',
          icon:'icon_address.svg'
        },
        {
          title:'TEL',
          oneLine:'TEL: +1 514 589 9985',
          twoLine:'Fax: +1 514 589 9985',
          content:' ',
          icon:'icon_phone.svg'
        },
        {
          title:'E-Mail',
          oneLine:'E-Mail: ',
          twoLine:'Joe.J@luckvenie.com',
          icon:'icon_email.svg'
        }
      ]
    }
  },
  created() {
    this.init();
  },
  methods:{
    init(){
      // this.$store.getters.getConfig.then(res => {
      //   this.config = res;
        this.items[0].oneLine = this.getConfig.address
        this.items[1].oneLine = 'TEL: +'+this.getConfig.phone;
        this.items[1].twoLine = 'TEL: +'+this.getConfig.phone1;
        this.items[2].twoLine = this.getConfig.mail;
      // });
    }
  }
}
</script>

<style lang="scss">
.advantage-box-title{
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
}

.advantage-box{
  padding: 0;
  list-style: none;
  margin-top: 20px!important;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px 20px;
}
.quality-box li img{
  width: 100%;
}
.quality-box li{
  border: 1px solid #bec2ca;
  border-radius: 8px;
  padding: 1px;
}
.quality-box{
  padding: 0;
  list-style: none;
  margin-top: 20px!important;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 20px 20px;
}
.contact-whatwedo-box-content-item-text{
  font-weight: bold;
}
.img-wrap img{
  width: 55px;
}
.img-wrap{
  background-color: #f7f5f6;
  width: 100px;
  height: 100px;
  margin: auto;
  border-radius: 20px;
}
.contact-whatwedo-box-content-item{
  max-width: 138px;
}
.contact-whatwedo-box-content{
  padding: 20px 20px;
}
.contact-whatwedo-box{
  padding-top: 20px;
  .contact-icon-box{
    width: 363px;
  }
}
.contact-warp-adv-content{
  padding-top: 12px;
}
.contact-warp-adv-title{
  margin: 0;
  line-height: 60px;
  font-size: 24px;
  color: #fff;
  font-weight: bold;
  position: relative;
  &::after{
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 42px;
    height: 3px;
    background: #ff9c00;
  }
}
.region-card{
  padding: 30px;
  width: 619px;
  border-radius: 10px;
  background: 100% 0/15.5% auto no-repeat #f3f7fb;
  ul{
    li{
      padding-bottom: 10px;
      span{
        font-size: 15px;
        margin-right: 6px;
      }
    }
  }
}
.contact-warp{
  width: 100%;
  height: 0;
  padding-top: 37.74%;
  position: relative;
  background-size: cover;
  background: url("/imgs/contactUs/banner.png");
}
.contact-warp-adv{
  position: absolute;
  top: 219px;
  left: 149px;
  height: 212px;
  width: 724px;
  background: linear-gradient(180deg,rgba(255,255,255,.28) 0,rgba(255,255,255,0) 100%);
  backdrop-filter: blur(34px);
  padding: 20px 20px 30px;
}
.icon-items{
  width: 80px;
  height: 80px;
  border-radius: 16px;
  background: #f7f5f6;
}
</style>
